<div class="p-multiselect p-component w-100 d-flex align-items-center position-relative"
  #wrapper
  [class.p-focus]="focused()"
  [class.p-multiselect-open]="open()"
  (click)="op.toggle($event, wrapper); toggleOpen()"
  (keydown.enter)="toggleOpen()"
  (keydown.space)="toggleOpen()"
  tabindex="0"
  role="combobox"
  [attr.aria-expanded]="open()"
>
  <div class="p-multiselect-label-container w-100 d-flex justify-content-between">
    <div class="p-multiselect-label overflow-hidden p-0" [class.p-placeholder]="!selectedLabels().length">
      <span>
        @if(selectedLabels().length) {
          {{ selectedLabels().join(', ') }}
          <div class="floating-label">
            {{placeholder()}}
          </div>
        }
        @else {
          {{ placeholder() }}
        }
      </span>
    </div>

    <div class="p-multiselect-trigger d-flex align-items-center justify-content-center">
      <span class="p-multiselect-trigger-icon pi" [ngClass]="{'pi-chevron-up': open(), 'pi-chevron-down': !open()}"></span>
    </div>
  </div>

  <p-popover #op appendTo="body" [style]="{width: '360px'}" (onHide)="searchQuery.set('')">
    <ng-template pTemplate="content">
      <div class="select-items-header w-100 row d-flex align-items-center p-3">
        <div class="col-1">
          <p-checkbox
            [ngModel]="areAllOptionsSelected()"
            (ngModelChange)="selectOrDeselectAll($event)"
            [binary]="true" data-testid="are-all-options-selected-checkbox"></p-checkbox>
        </div>

        <div class="col-9">
          <p-iconField iconPosition="right">
            <input
              pInputText
              [ngModel]="searchQuery()"
              (ngModelChange)="searchQuery.set($event)"
              type="text"
              class="w-100" data-testid="search-query-input">
            <p-inputIcon styleClass="pi pi-search" />
          </p-iconField>
        </div>

        <div class="col-2">
          <button pButton class="close-button" icon="pi pi-times" [rounded]="true" [text]="true" (click)="op.hide()" data-testid="op-hide-btn"></button>
        </div>
      </div>

      <div cdkDropList class="select-items-body" (cdkDropListDropped)="dropOption($event)">
        @for(option of displayOptions(); track option.value) {
          <div cdkDrag class="row d-flex align-items-center selectable-option p-3" (click)="selectItem(option)">
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <div (click)='$event.stopPropagation()' class='col-1'>
              <i cdkDragHandle class="fa fa-grip-vertical me-3 grip-icon" (click)="$event.stopPropagation()"></i>
            </div>

            <div class="col-1">
              <p-checkbox [ngModel]="option.selected" (ngModelChange)="selectItem(option)" [binary]="true" (click)="$event.stopPropagation()" data-testid="selected-checkbox"></p-checkbox>
            </div>

            <div class="col-9">
              {{option.label}}
            </div>
          </div>
        }
      </div>
    </ng-template>
  </p-popover>
</div>


